import styled from 'styled-components';

import { flexSpaceBetween, flexStart } from '../../../style/reusableStyle';

export const ViewJobContainerStyled = styled.div`
  margin: 18px 0px 200px;
  & .contents {
    margin-left: 30px;
  }
  & .heading {
    ${flexSpaceBetween(15)};
    max-width: 700px;
  }

  & .section-title {
    margin-bottom: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    & .contents {
      margin-left: 0px;
    }
  }
`;

export const InfoRow = styled.div`
  width: 100%;
  ${flexStart};
  gap: 10px;
  margin-bottom: 20px;
  & .title {
    width: 150px;
    color: ${({ theme }) => theme.colors.darkText};
    flex-shrink: 0;
  }
  & .value {
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;

    & .title {
      font-weight: 600;
    }
  }
`;

export const ActionsContainer = styled.div`
  ${flexStart};
  gap: 24px;
`;

//------------Printer Job Details----------
export const PrinterJobDetailsStyled = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    & .value {
      font-size: 12px;
    }
    & .jobInformation {
      display: flex;
      flex-direction: row;
    }
  }
`;
//------------Draftman Job Details----------
export const DraftmanJobDetailsStyled = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    & .value {
      font-size: 12px;
    }
    & .jobInformation {
      display: flex;
      flex-direction: row;
    }
  }
`;
